// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPromo_root__137VU","link":"LoginPromo_link__-MwiB"};